import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import ModalHeader from 'react-bootstrap/ModalHeader'
import ModalTitle from 'react-bootstrap/ModalTitle';
import ModalBody from 'react-bootstrap/ModalBody'

const ModalGlobal = ({ show, onClose, size, title, children, footer }) => {
  return (
    <Modal
      show={show} onHide={onClose}
      size={size ?? "lg"}
      centered
    >
      {title && (
        <ModalHeader closeButton>
          <ModalTitle><h6 className='text-xl text-main-one-600 mb-0'>{title ?? ""}</h6></ModalTitle>
        </ModalHeader>
      )}
      <ModalBody>{children}</ModalBody>
    </Modal>
  );
}

export default ModalGlobal;